/** True while the visible query differs from the debounced query driving fetches. */
export function isQueryDebouncing(input, debouncedQuery) {
  return input.trim() !== debouncedQuery.trim();
}

/** Show loading / keep prior results — never an empty terminal state while unresolved. */
export function isSearchInFlight({ input, debouncedQuery, isLoading = false, isFetching = false }) {
  if (!input.trim()) return false;
  if (isQueryDebouncing(input, debouncedQuery)) return true;
  return isLoading || isFetching;
}

/** Only when debounce settled, fetch finished, and zero matches. */
export function shouldShowSearchEmpty({
  input,
  debouncedQuery,
  isLoading = false,
  isFetching = false,
  resultCount = 0,
}) {
  if (!debouncedQuery.trim()) return false;
  if (isSearchInFlight({ input, debouncedQuery, isLoading, isFetching })) return false;
  return resultCount === 0;
}
